import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BaseAbsenceRequestsState } from '../reducers/base-absence-requests.reducer';

export const ABSENCE_REQUESTS_FEATURE_KEY = 'absenceRequests';

const getAbsenceRequestsState = createFeatureSelector<BaseAbsenceRequestsState>(ABSENCE_REQUESTS_FEATURE_KEY);

export const getAbsenceRequestsList = createSelector(getAbsenceRequestsState, (state) => state.list);
export const getDashboardAbsenceRequests = createSelector(getAbsenceRequestsState, (state) => state.dashboard);
export const getEmployees = createSelector(getAbsenceRequestsState, (state) => state.employees);
